import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppRouteChangeService {

  constructor(private router: Router) {

    router.events.subscribe((event) => {
      router.events
        .pipe(filter(event => event instanceof NavigationStart))
        .subscribe((event) => {
          // if (event.url.includes('/avls/')) {
          //   window.location.href = 'http://bmtcitms.amnex.com' + event.url;
          // }

        });
    });
  }
}